import { cn } from "@/lib/utils";

/** Vybe mark; uses `currentColor` so it follows theme via `text-foreground`. */
export function VybeLogo({
  className,
  title = "Vybe Trader",
  decorative,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  /** Accessible label / SVG title for the mark. */
  title?: string;
  /** When true, hide from assistive tech (parent provides a label). */
  decorative?: boolean;
}) {
  return (
    <svg
      viewBox="0 0 250 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0 text-foreground", className)}
      role={decorative ? "presentation" : "img"}
      aria-hidden={decorative ? true : undefined}
      aria-label={decorative ? undefined : title}
      {...props}
    >
      {!decorative ? <title>{title}</title> : null}
      <g fill="currentColor">
        <rect x="15" y="67" width="40" height="30" />
        <rect x="35" y="110" width="80" height="30" />
        <rect x="95" y="67" width="140" height="30" />
        <rect x="55" y="153" width="40" height="30" />
        <rect x="145" y="110" width="40" height="30" />
        <rect x="145" y="153" width="40" height="30" />
      </g>
    </svg>
  );
}
